module.exports = __webpack_public_path__ + "media/src/images/jpx_banner-1e3db5352874ff663d029792d68d3075.png";